import { createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1edf93ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  ref: "stripEl",
  class: "nge-tagmode-mini"
}
const _hoisted_2 = ["onPointerdown", "innerHTML"]
const _hoisted_3 = ["title", "onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["title"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["onPointerdown"]
const _hoisted_10 = {
  key: 0,
  class: "nge-tagmode-flash nge-tagmode-flash--mini"
}
const _hoisted_11 = ["onPointerdown"]
const _hoisted_12 = { class: "nge-tagmode-title" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-tagmode-hint" }, [
  /*#__PURE__*/_createTextVNode(" Pick a type, then "),
  /*#__PURE__*/_createElementVNode("b", null, "hold T and click"),
  /*#__PURE__*/_createTextVNode(" the spot, or "),
  /*#__PURE__*/_createElementVNode("b", null, "tap T"),
  /*#__PURE__*/_createTextVNode(" to arm Click to tag. "),
  /*#__PURE__*/_createElementVNode("b", null, "Submit"),
  /*#__PURE__*/_createTextVNode(" saves it. ")
], -1 /* HOISTED */))
const _hoisted_15 = { class: "nge-tagmode-chips" }
const _hoisted_16 = ["title", "onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "nge-tagmode-extras" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "No annotation layer", -1 /* HOISTED */))
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "nge-tagmode-foot" }
const _hoisted_24 = { class: "nge-tagmode-coords-label" }
const _hoisted_25 = ["title"]
const _hoisted_26 = { class: "nge-tagmode-actions-row" }
const _hoisted_27 = ["title"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = ["disabled", "title"]
const _hoisted_30 = {
  key: 0,
  class: "nge-tagmode-flash"
}
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-tagmode-success-title" }, "Tag complete!", -1 /* HOISTED */))
const _hoisted_33 = { class: "nge-tagmode-success-pos" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-tagmode-success-hint" }, "tagged for the Scythes · click or Enter to keep scouting", -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      ref: "wrapEl",
      class: _normalizeClass(["nge-tagmode-wrap", { 'nge-tagmode-wrap--armed': $setup.tHeld || $setup.armedOnce }]),
      style: _normalizeStyle({ left: $setup.panelPos.left + 'px', top: $setup.panelPos.top + 'px' })
    }, [
      _createCommentVNode(" Collapsed corner strip: chips + place + submit, nothing else "),
      ($setup.collapsed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("span", {
              class: "nge-tagmode-mini-grip",
              title: "Drag",
              onPointerdown: _withModifiers($setup.dragStart, ["prevent"]),
              innerHTML: $setup.pinSvg
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.TAG_CHOICES, (c) => {
              return _createElementVNode("button", {
                key: c.key,
                class: _normalizeClass(["nge-tagmode-mini-chip", { 'nge-tagmode-mini-chip--active': $setup.selected === c.key }]),
                title: c.hint,
                onClick: $event => ($setup.miniChoose(c.key))
              }, [
                (c.key === 'cut')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: $setup.scytheIcon,
                      class: "nge-tagmode-chip-img",
                      alt: ""
                    }, null, 8 /* PROPS */, _hoisted_4))
                  : (c.key === 'extend')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: $setup.tracerIcon,
                        class: "nge-tagmode-chip-img",
                        alt: ""
                      }, null, 8 /* PROPS */, _hoisted_5))
                    : _createCommentVNode("v-if", true),
                _createTextVNode(_toDisplayString(c.key === 'cut' ? 'Cut' : c.key === 'extend' ? 'Extend' : 'Other'), 1 /* TEXT */)
              ], 10 /* CLASS, PROPS */, _hoisted_3)
            }), 64 /* STABLE_FRAGMENT */)),
            _createElementVNode("button", {
              class: _normalizeClass(["nge-tagmode-mini-act", { 'nge-tagmode-mini-act--on': $setup.armedOnce || $setup.tHeld }]),
              title: $setup.armedOnce ? 'Click the data to place the point (tap T to disarm)' : 'Place point with next click (tap T)',
              onClick: $setup.armOnce
            }, [
              _createElementVNode("span", {
                class: "nge-tagmode-pin",
                innerHTML: $setup.pinSvg
              }, null, 8 /* PROPS */, _hoisted_7)
            ], 10 /* CLASS, PROPS */, _hoisted_6),
            _createElementVNode("button", {
              class: "nge-tagmode-mini-act nge-tagmode-mini-submit",
              disabled: $setup.saving,
              title: "Submit tag",
              onClick: $setup.submit
            }, "✓", 8 /* PROPS */, _hoisted_8),
            _createElementVNode("button", {
              class: "nge-tagmode-mini-act",
              title: "Expand panel",
              onClick: _cache[0] || (_cache[0] = $event => ($setup.setCollapsed(false)))
            }, "▴"),
            _createElementVNode("button", {
              class: "nge-tagmode-mini-act nge-tagmode-mini-close",
              title: "Exit tag mode (Esc)",
              onClick: $setup.closeWithZip
            }, "×"),
            _createElementVNode("span", {
              class: "nge-tagmode-mini-hand",
              title: "Drag to move",
              onPointerdown: _withModifiers($setup.dragStart, ["prevent"]),
              innerHTML: $setup.HAND_SVG
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_9),
            ($setup.flash)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.flash), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ], 512 /* NEED_PATCH */))
        : ($setup.phase === 'form' || $setup.phase === 'form-out')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" Form box "),
              _createElementVNode("div", {
                ref: "boxEl",
                class: _normalizeClass(["nge-tagmode", { 'nge-holo-out': $setup.phase === 'form-out', 'nge-tagmode--drawing': $setup.drawingIn }])
              }, [
                _createElementVNode("div", {
                  class: "nge-tagmode-head",
                  onPointerdown: _withModifiers($setup.dragStart, ["prevent"])
                }, [
                  _createElementVNode("span", _hoisted_12, [
                    _createElementVNode("span", {
                      class: "nge-tagmode-pin",
                      innerHTML: $setup.pinSvg
                    }, null, 8 /* PROPS */, _hoisted_13),
                    _createTextVNode(" SCOUT TAG MODE")
                  ]),
                  _createElementVNode("button", {
                    class: "nge-tagmode-close",
                    title: "Collapse to corner strip",
                    onPointerdown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                    onClick: _cache[2] || (_cache[2] = $event => ($setup.setCollapsed(true)))
                  }, "▾", 32 /* HYDRATE_EVENTS */),
                  _createElementVNode("button", {
                    class: "nge-tagmode-close",
                    title: "Exit tag mode (Esc)",
                    onPointerdown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                    onClick: $setup.closeWithZip
                  }, "×", 32 /* HYDRATE_EVENTS */)
                ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_11),
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.TAG_CHOICES, (c) => {
                    return _createElementVNode("button", {
                      key: c.key,
                      class: _normalizeClass(["nge-tagmode-chip", {
              'nge-tagmode-chip--active': $setup.selected === c.key,
              'nge-tagmode-chip--cut': c.key === 'cut',
              'nge-tagmode-chip--ext': c.key === 'extend',
              'nge-tagmode-chip--other': c.key === 'other',
            }]),
                      title: c.hint,
                      onClick: $event => ($setup.choose(c.key))
                    }, [
                      (c.key === 'cut')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: $setup.scytheIcon,
                            class: "nge-tagmode-chip-img",
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_17))
                        : (c.key === 'extend')
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: $setup.tracerIcon,
                              class: "nge-tagmode-chip-img",
                              alt: ""
                            }, null, 8 /* PROPS */, _hoisted_18))
                          : _createCommentVNode("v-if", true),
                      _createTextVNode(_toDisplayString(c.key === 'cut' ? ' Cut' : c.label.replace(/^\S+\s/, '')), 1 /* TEXT */)
                    ], 10 /* CLASS, PROPS */, _hoisted_16)
                  }), 64 /* STABLE_FRAGMENT */))
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.note) = $event)),
                  class: "nge-tagmode-note",
                  placeholder: $setup.selectedChoice.tagType === 'other' ? 'Describe it…' : 'Optional note…',
                  onKeydown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                  onKeyup: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                  onKeypress: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_19), [
                  [_vModelText, $setup.note]
                ]),
                _createElementVNode("div", _hoisted_20, [
                  ($setup.annotationLayers().length)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.annotationLayer) = $event)),
                        class: "nge-tagmode-select"
                      }, [
                        _hoisted_21,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.annotationLayers(), (l) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: l,
                            value: l
                          }, "📐 " + _toDisplayString(l), 9 /* TEXT, PROPS */, _hoisted_22))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */)), [
                        [_vModelSelect, $setup.annotationLayer]
                      ])
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("button", {
                    class: "nge-tagmode-shot",
                    onClick: _cache[9] || (_cache[9] = $event => ($setup.showScreenshotDialog = true))
                  }, _toDisplayString($setup.screenshotUrl ? '🖼 Attached ✓' : '📸 Screenshot'), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["nge-tagmode-coords", { 'nge-tagmode-pos--pending': $setup.pendingPos }])
                  }, [
                    _createElementVNode("span", _hoisted_24, _toDisplayString($setup.pendingPos ? 'point' : 'coordinates') + ":", 1 /* TEXT */),
                    _createElementVNode("span", {
                      class: "nge-tagmode-coords-vals",
                      title: $setup.pendingPos ? 'Placed point, Submit saves it (click again to move)' : 'Crosshair position'
                    }, [
                      _createElementVNode("b", null, "(" + _toDisplayString(($setup.pendingPos ?? $setup.crosshairPosition()).join(', ')) + ")", 1 /* TEXT */),
                      _createElementVNode("button", {
                        class: "nge-tagmode-copy",
                        title: "Copy coordinates",
                        onClick: $setup.copyCoords
                      }, "⧉")
                    ], 8 /* PROPS */, _hoisted_25)
                  ], 2 /* CLASS */),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["nge-tagmode-arm", { 'nge-tagmode-arm--on': $setup.armedOnce }]),
                      title: $setup.armedOnce ? 'Armed: click the data to place the point (tap T to disarm)' : 'Arm it: your next click places the point (tap T)',
                      onClick: $setup.armOnce
                    }, [
                      ($setup.armedOnce)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("Click the spot…")
                          ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("span", {
                              class: "nge-tagmode-pin",
                              innerHTML: $setup.pinSvg
                            }, null, 8 /* PROPS */, _hoisted_28),
                            _createTextVNode(" Click to tag")
                          ], 64 /* STABLE_FRAGMENT */))
                    ], 10 /* CLASS, PROPS */, _hoisted_27),
                    _createElementVNode("button", {
                      ref: "submitBtnEl",
                      class: "nge-tagmode-btn",
                      disabled: $setup.saving,
                      title: $setup.pendingPos ? 'Save the placed point' : 'Tag the crosshair position',
                      onClick: $setup.submit
                    }, " Submit ", 8 /* PROPS */, _hoisted_29)
                  ])
                ]),
                ($setup.flash)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString($setup.flash), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */)
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createCommentVNode(" Success box: click to play the cycle back to the form "),
              _createElementVNode("div", {
                class: _normalizeClass(["nge-tagmode nge-tagmode--success", { 'nge-holo-out': $setup.phase === 'success-out', 'nge-tagmode--frameless': $setup.successFrameless, 'nge-tagmode--building': $setup.successBuilding, 'nge-tagmode--spinout': $setup.successSpin }]),
                style: _normalizeStyle($setup.successSize),
                onClick: $setup.dismissSuccess,
                title: "Click to keep scouting"
              }, [
                _createElementVNode("img", {
                  class: "nge-tagmode-success-scythes",
                  src: $setup.superScytheUrl,
                  alt: ""
                }, null, 8 /* PROPS */, _hoisted_31),
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, "(" + _toDisplayString($setup.lastTag?.pos.join(', ')) + ")", 1 /* TEXT */),
                _hoisted_34
              ], 6 /* CLASS, STYLE */)
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
    ], 6 /* CLASS, STYLE */),
    _createVNode($setup["ScreenshotDialog"], {
      show: $setup.showScreenshotDialog,
      mode: "attach",
      onClose: _cache[10] || (_cache[10] = $event => ($setup.showScreenshotDialog = false)),
      onAttached: _cache[11] || (_cache[11] = p => { $setup.screenshotUrl = p.url; $setup.showScreenshotDialog = false; })
    }, null, 8 /* PROPS */, ["show"])
  ]))
}